import { Controller } from "@hotwired/stimulus";
import * as Turbo from "@hotwired/turbo";
import { formSubmitWithWaitForJobCompletion } from '../jobCompletion';
import { FormDataSaver } from "../formDataSaver";
import { translate } from "../translate";
import * as TranslationsKeys from "../locale/translationsKeys";
import { buildUploadComponent } from '../fileUpload';
import { dialogConfirmationButtonClassName, dialogCancelButtonClassName } from "../dialogConstants";
import { trackEvent } from "../../Features/Analytics";

export default class CreateOrEditController extends Controller {
    static targets = [
        "form",
        "label",
        "photoUploader",
        "unsavedChanges"
    ];

    static values = {
        getJobUrl: String,
        poiDetailUrl: String,
        shouldEnableDataValidationInputName: String
    }

    readonly formTarget!: HTMLElement;
    readonly labelTargets!: HTMLElement[];
    readonly photoUploaderTarget!: HTMLElement;
    readonly unsavedChangesTarget!: HTMLElement;

    readonly getJobUrlValue!: string;
    readonly poiDetailUrlValue!: string;
    readonly shouldEnableDataValidationInputNameValue!: string;
    formDataSaver!: FormDataSaver;

    connect() {
        const form = $(this.formTarget);
        this.formDataSaver = new FormDataSaver(this.formTarget as HTMLFormElement);

        formSubmitWithWaitForJobCompletion(
            form,
            $(".submit"),
            this.getJobUrlValue,
            () => {
                trackEvent('placeSaved');
                this.formDataSaver.stopPeriodicFormDataSaving();
                this.formDataSaver.clearSavedFormData();
                Turbo.clearCache();

                const urlParams = new URLSearchParams(window.location.search);
                const navigateToPoiDetailOnSave = urlParams.get("navigateToPoiDetailOnSave") === "True";

                if (navigateToPoiDetailOnSave) {
                    Turbo.visit(this.poiDetailUrlValue);
                } else {
                    const navigateTwiceBackOnSave = urlParams.get("navigateBackTwiceOnSave") === "True";
                    history.go(navigateTwiceBackOnSave ? -2 : -1);
                }
            },
            undefined,
            this.shouldEnableDataValidationInputNameValue
        );

        if (this.formDataSaver.hasSavedFormData()) {
            this.formDataSaver.loadSavedFormData();
            $(this.unsavedChangesTarget).show();
        }

        buildUploadComponent($(this.photoUploaderTarget));

        this.formDataSaver.setupPeriodicFormDataSaving();
    }

    disconnect() {
        this.formDataSaver?.stopPeriodicFormDataSaving();
    }

    cancel() {
        const formDataSaver = this.formDataSaver;
        bootbox.confirm({
            message: translate(TranslationsKeys.Global_CancelEditing_Message),
            buttons: {
                confirm: {
                    label: translate(TranslationsKeys.Global_Ok),
                    className: dialogConfirmationButtonClassName
                },
                cancel: {
                    label: translate(TranslationsKeys.Global_Cancel),
                    className: dialogCancelButtonClassName
                }
            },
            callback(result) {
                if (!result) return;

                formDataSaver.stopPeriodicFormDataSaving();
                formDataSaver.clearSavedFormData();
                history.back();
            }
        });
    }
 }
